<template>
  <modal class="study-set-mode" v-bind="$attrs" v-on="$listeners" width="788px" center>
    <template v-slot:title>
      <img src="@/assets/images/study-mode-header.svg" />
    </template>
    <template v-slot:body>
      <div class="popup-paragraph">
        <h2 class="popup-paragraph__title">
          Choosing a Study Mode
        </h2>
      </div>
      <div class="item">
        <study-mode-item
          :left="{ images: ['study-mode-faq-1.png'] }"
          :right="[
            {
              title: 'Pronunciation Skills',
              desc: 'Description of the mode:',
              text:
                'In Pronunciation Skills mode, your learners will practice speaking words, phrases, and sentences based on the study set content you have created, up to 300 characters per study set item.',
            },
          ]"
        />
        <study-mode-item
          :left="{ images: ['study-mode-faq-2.png'] }"
          :right="[
            {
              desc: 'How it works:',
              text:
                'Study set items appear one by one in their list order. ELSA models the correct pronunciation, and the learner listens then repeats what ELSA says. Learners receive detailed pronunciation feedback and can retry for a higher score as many times as they like to perfect their speaking.',
            },
          ]"
        />
        <span class="item__line"></span>
        <study-mode-item
          :left="{
            images: ['study-mode-faq-3.png', 'study-mode-faq-4.png', 'study-mode-faq-5.png'],
          }"
          :right="[
            {
              title: 'Vocabulary Skills (Beta version)',
              desc: 'Description of the mode:',
              text:
                'In Vocabulary Skills mode, learners play a mix of language games based on the four macro skills of English (Listening, Speaking, Reading, Writing). This mode is useful for practicing and improving vocabulary retention of study set content.',
              note:
                'This mode is currently in Beta release, so not every study set will be compatible with all 4 English skill games. We plan to continue releasing new vocabulary games in the future.',
            },
            {
              desc: 'How it works:',
              text:
                'Each item in the study set is shown to the learner in order with its definition, translation, and pronunciation. <br/>The study set is then shuffled and presented to the learner in a randomized order. The learner must recall the correct sound, pronunciation, word meaning, and spelling from memory. Each game type practices a different English skill so learners can train their vocabulary skills holistically.<br/><br/>',
            },
            {
              desc: `Why it's effective:`,
              text:
                'Vocabulary Skills mode is based on two study strategies for effective learning: Spacing and Retrieval Practice. <br/><br/>Spacing involves the repeated practice of new material to improve memory retention and knowledge transfer. We recommend assigning a study set to your learners multiple times in Vocabulary Skills to give them many opportunities to practice and retain new vocabulary. <br/><br/>Retrieval Practice (RP) involves teaching learners new information and then quizzing them on it with flashcards or a practice test, which compels learners to retrieve the information from memory. The effectiveness of RP has been validated by more than a century of research. Learners who use RP are typically better able to remember new information than those that do not.',
              tooltip:
                'Carpenter, Shana & Pan, Steven & Butler, Andrew. (2022). The science of effective learning with a focus on spacing and retrieval practice.',
            },
          ]"
        />
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import StudyModeItem from "./StudyModeItem.vue";

export default {
  components: {
    Modal,
    StudyModeItem,
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-height: 1410px) {
  .study-set-mode {
    padding-right: 15px;
  }
}

.study-set-mode {
  padding-top: 9vh;

  ::v-deep .el-dialog__body {
    padding: 20px 40px !important;
    overflow-y: auto;
    margin: 20px 0;
    max-height: 480px;
  }
  .popup-paragraph {
    margin-bottom: 20px;

    &__title {
      font-weight: bold;
      font-size: 26px;
      line-height: 38px;
      color: #2f1e96;
    }
  }
  .item {
    display: flex;
    width: 100%;

    &__line {
      border-bottom: 1px solid #e5e5ea;
      margin: 10px 0;
    }
  }
}
.el-popup-parent--hidden .study-set-container .el-dialog__wrapper {
  overflow: hidden;
}
</style>
